import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { createElement, forwardRef } from '@wordpress/element';
export function Button(props, ref) {
  var href = props.href,
      target = props.target,
      isPrimary = props.isPrimary,
      isLarge = props.isLarge,
      isSmall = props.isSmall,
      isTertiary = props.isTertiary,
      isToggled = props.isToggled,
      isBusy = props.isBusy,
      isDefault = props.isDefault,
      isLink = props.isLink,
      isDestructive = props.isDestructive,
      className = props.className,
      disabled = props.disabled,
      additionalProps = _objectWithoutProperties(props, ["href", "target", "isPrimary", "isLarge", "isSmall", "isTertiary", "isToggled", "isBusy", "isDefault", "isLink", "isDestructive", "className", "disabled"]);

  var classes = classnames('components-button', className, {
    'is-button': isDefault || isPrimary || isLarge || isSmall,
    'is-default': isDefault || !isPrimary && (isLarge || isSmall),
    'is-primary': isPrimary,
    'is-large': isLarge,
    'is-small': isSmall,
    'is-tertiary': isTertiary,
    'is-toggled': isToggled,
    'is-busy': isBusy,
    'is-link': isLink,
    'is-destructive': isDestructive
  });
  var tag = href !== undefined && !disabled ? 'a' : 'button';
  var tagProps = tag === 'a' ? {
    href: href,
    target: target
  } : {
    type: 'button',
    disabled: disabled
  };
  return createElement(tag, _objectSpread({}, tagProps, additionalProps, {
    className: classes,
    ref: ref
  }));
}
export default forwardRef(Button);
//# sourceMappingURL=index.js.map